(function(){
  function initialise(){
    var root=document.querySelector('[data-moqua-spare-accordions]');
    if(!root)return;
    function reveal(){
      var id=window.location.hash.slice(1);
      if(!['moqua-jrg-auswahl','moqua-nussbaum-auswahl'].includes(id))return;
      var target=root.querySelector('#'+id);
      if(!target)return;
      target.open=true;
      root.querySelectorAll('details').forEach(function(item){if(item!==target)item.open=false;});
    }
    reveal();
    if(root.dataset.initialised)return;
    root.dataset.initialised='true';
    window.addEventListener('hashchange',reveal);
    root.querySelectorAll('details').forEach(function(item){item.addEventListener('toggle',function(){if(item.open)root.querySelectorAll('details').forEach(function(other){if(other!==item)other.open=false;});});});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialise);else initialise();
  document.addEventListener('shopify:section:load',initialise);
})();
